<template>
  <div class="routerInfo">

    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <font-awesome-icon class="mainblock-icon" style="color: red" icon="newspaper"></font-awesome-icon>
            <a  class="mainblock-label">试题浏览</a>
          </div>
        </div>
        <div class="container-body">
          <div class="party-right">
            <el-row>
              <el-col :span="6">
                <el-input
                  placeholder="输入关键字进行过滤"
                  v-model="filterText">
                </el-input>
                <el-tree
                  class="filter-tree"
                  :data="bankTree"
                  :props="defaultProps"
                  :filter-node-method="filterNode"
                  @node-click="handleNodeClick"
                  ref="tree">
                </el-tree>
              </el-col>
              <el-col :span="16">
                <el-select v-model="questionType" placeholder="请选择" @change="questionTypeChange">
                  <el-option
                    v-for="item in questionTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-tag v-show="tikuShow">{{tiku}}</el-tag>
                <el-tag v-show="tikuShow" type="warning">总题数:{{questionTotal}}</el-tag>
                <el-table :data="questionList" stripe style="width: 100%">
                  <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                      <span v-text="getIndex(scope.$index)"> </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="questionType"
                    label="题型"
                    width="80">
                    <template slot-scope="scope">{{ questionTypeDict[scope.row.questionType] || '未知' }}</template>
                  </el-table-column>
                  <el-table-column
                    prop="questionContent"
                    label="题目"
                    width="520">
                    <template slot-scope="scope">
                    <span v-html="scope.row.questionContent"></span>
                    <p>
                      <div  v-for="answer in scope.row.answerList"
                            class="answerContainer">
                        <span v-html="answer.optionName"></span>、
                        <span v-if="scope.row.questionType>1" v-html="answer.answerContent"></span>
                      </div>
                    </p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    prop="solution"
                    label="答案"
                    width="100">
                    <template slot-scope="scope">{{ solutionDict[scope.row.solution] || scope.row.solution }}</template>
                  </el-table-column>
                </el-table>
                <el-button type="primary" v-show="pageShow" v-on:click="prePage()">上一页</el-button>
                <el-button type="primary" v-show="pageShow" v-on:click="nextPage()">下一页</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="详情" :visible.sync="dialogFormVisible">
      <el-form :model="question">
        <div class="questionRow">
          <div class="type" v-if="question.questionType == 1" style="color: green">判断题</div>
          <div class="type" v-if="question.questionType == 2" style="color: blue">单选题</div>
          <div class="type" v-if="question.questionType == 3" style="color: darkblue">多选题</div>
          <div class="questionContent" v-html="question.questionContent"></div>
        </div>
        <div  v-for="answer in question.answerList"
              class="answerContainer">
          <div @click="toChooseAnswer(question,answer)"
               :class="answer.selected?'answer-choose':'answer-bg'"
               v-if="question.questionType>1"
               v-html="answer.optionName"></div>
          <div class="answerContent" v-if="question.questionType>1" v-html="answer.answerContent"></div>

          <div @click="toChooseAnswer(question,answer)"
               :class="answer-choose"
               v-if="question.questionType==1"
               v-html="answer.showName"></div>
          <div class="answerContent" v-if="question.questionType==1" v-html="answer.answerContent"></div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitQuestion()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style rel='stylesheet/less' lang='less' scoped>
  @import "../../assets/less/variables.less";
  @import "../../assets/less/mySearch.less";
  @import "../../assets/less/style.less";
  .answer-bg{
    margin-left: 20px;
    word-wrap:break-word;
    border: 1px #616161 solid;
    border-radius: 4px;
    background: #fafafa;
    color: #616161;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .answerContainer{
    display: flex;
    margin-top: 20px;
  }
  .answerContent{
    margin-left: 10px;
    display: flex;
    align-items: center;
    min-height: 30px;
  }
  .answer-choose{
    width: 30px;
    height: 30px;
    margin-left: 20px;
    word-wrap:break-word;
    border: 1px #409EFF solid;
    border-radius: 15px;
    background: #409EFF;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;

  }
  .questionContent{
    width: 1000px;
    float:left;
    text-overflow:ellipsis;
    overflow:hidden;
  }
</style>

<script type="text/ecmascript-6">
  import viewFunction from "../../assets/js/viewFunction";
  import { mapState, mapGetters ,mapMutations} from 'vuex'
  import { Loading } from 'element-ui'
  const moment = require('moment')
  export default {
    name: 'Training',
    inject:['check'],
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    data(){
      return {
        examList: [],
        loadLoading: false,
        examStatus: 0,
        pageNum:1,
        pageTotal:0,
        pageSize:10,
        bankTree:[],
        filterText: '',
        questionList:[],
        dialogFormVisible: false,
        questionType:'',
        questionTotal:0,
        bankId:0,
        pageShow:false,
        tiku:"",
        tikuShow:false,
        questionTypeDict:{
          1:'判断题',
          2:'单选题',
          3:'多选题',
          4:'计算题',
          5:'填空题',
          6:'问答题',
          7:'技能题',
          8:'简答题',
          9:'名词解释',
          10:' 绘图题',
          11:'论述题',
          12:'案例分析',
          13:'综合题',
          14:'视图题',
          15:'选答题',
          16:'改错题',
          17:'操作题'
        },
        solutionDict:{
          T:'正确',
          F:'错误'
        },
        questionTypeOptions:[
          {label: '全部', value: ''},
          {label: '判断题', value: 1},
          {label: '单选题', value: 2},
          {label: '多选题', value: 3}
        ],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        question: {
          questionType: '',
          questionContent: ''
        }
      }
    },
    filters: {

    },
    mounted() {
      this.examStatus = 0
      this.findQuestionBankTree()
    },
    computed: {
      ...mapState({
        user: state => state.user
      }),
      ...mapGetters({
        navigationList: 'navs'
      })
    },
    methods:{
      questionTypeChange(value){
        this.questionType = value
        if(this.bankId > 0){
          this.findQuestionByBankId(this.bankId)
        }
      },
      submitQuestion(){
        let solution = ''
        if (this.question.questionType === 3){
          //多选题
          for (let i=0;i<this.question.answerList.length;i++){
            if(this.question.answerList[i].selected){
              solution = solution + this.question.answerList[i].optionName
            }
          }
        }else{
          for (let i=0;i<this.question.answerList.length;i++){
            if(this.question.answerList[i].selected){
              solution = this.question.answerList[i].optionName
            }
          }
        }
        if(solution === this.question.solution){
          this.$message({
            message: '恭喜你，回答正确！',
            type: 'success'
          });
        }else{
          this.$message({
            message: '回答错误！',
            type: 'error'
          });
        }
      },
      toChooseAnswer(question,answer){
        if (question.questionType == 3){
          answer.selected = !answer.selected
        }else {
          for (let i=0;i<question.answerList.length;i++){
            question.answerList[i].selected = false
          }
          answer.selected = true
        }
        this.$forceUpdate();
      },
      getIndex(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      handleClick(row){
        //console.log(row)
        this.dialogFormVisible = true
        this.question = row
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      findQuestionBankTree() {
        let url = '/api/questionBank/findQuestionBankByTree'
        let that = this
        this.axios.post(url, {}).then(res => {
          viewFunction.handlerRes(that, res, function () {
            that.bankTree = JSON.parse(JSON.stringify(res.data))
          })
        })
      },
      findQuestionByBankId(first){
        if(first === 1){

        }else{
          this.pageNum = 1
        }
        this.pageTotal = 0
        if(this.questionType == 1){
          this.pageSize = 10
        }else{
          this.pageSize = 5
        }
        var params = {
          pageNum:this.pageNum,
          pageSize: this.pageSize,
          questionBankId:this.bankId,
          questionType:this.questionType
        }
        let url = '/api/question/findQuestionByMuluIdPage'
        let that = this
        this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
          that.questionTotal = res.data.total
          if(that.questionTotal > 0){
            if(that.questionTotal%that.pageSize == 0){
              that.pageTotal = that.questionTotal/that.pageSize
            }else{
              that.pageTotal = that.questionTotal/that.pageSize + 1
            }
          }
          that.questionList = res.data.questionList
          that.pageShow = that.questionList.length > 0;
        }))
      },
      handleNodeClick(data){
        if(data.children == null){
          this.pageNum = 1
          this.bankId = data.value
          this.findQuestionByBankId()
          this.tiku = this.getItemByIdInTree(this.bankTree,data.value)
          this.tikuShow = true
        }
      },
      /**
       * 3、通过某个节点的id，获取其父级名称（或其他）的完整路径信息
       * @param {*} tree 树结构数组
       * @param {*} value 当前节点的id
       * @returns
       */
      getItemByIdInTree(tree,value,path=""){
        for(var i=0;i<tree.length;i++){
          let tempPath = path
          tempPath =  `${tempPath ? tempPath + '-' : tempPath}${tree[i].label}` // 避免出现在最前面的/
          if(tree[i].value == value){
            return tempPath
          } else if(tree[i].children){
            let reuslt = this.getItemByIdInTree(tree[i].children,value,tempPath)
            if(reuslt){
              return reuslt
            }
          }
        }
      },
      formattedTime(time) {
        return moment(time).format('YYYY-MM-DD HH:mm:ss');
      },
      prePage(){
        if(this.pageNum > 1){
          this.pageNum = this.pageNum - 1
          this.findQuestionByBankId(1)
        }else{
          this.$message({
            message: '已经是第一页',
            type: 'warning'
          });
        }
      },
      nextPage(){
        if((this.pageNum + 1) > this.pageTotal){
          this.$message({
            message: '已经是最后一页',
            type: 'warning'
          });
        }else{
          this.pageNum = this.pageNum + 1
          this.findQuestionByBankId(1)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/learn/QuestionList.vue